<app-header [patientId]="patientId"></app-header>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-5 col-xl-4 body-style">
            <div class="row">
                <div class="text-light patient-info">
                    <div *ngFor="let header of headers">
                        <strong>{{header}}:</strong>
                        <span> {{row[header]}}</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <app-scores-chart class="findings col-md-6 offset-md-3 col-lg-12 offset-lg-0" [patientId]="patientId"></app-scores-chart>
            </div>
        </div>
        <div class="col-lg-7 col-xl-8">
            <app-image-viewer [imgSrc]="imgSrc" [calledFromCarousel]="false"></app-image-viewer>
        </div>
    </div>
    <div class="carousel-container row">
        <app-carousel [patientId]="patientId"></app-carousel>
    </div>
</div>